<template>
  <el-dialog
    id="introductoryDoc"
    :visible.sync="showLocal"
    top="5vh"
    width="900px"
    center
  >
    <div class="header defaultCursor">
      <div class="title">
        {{ $t('leader.coach.selectionDocTitle') }}
      </div>
      <div class="desc">
        {{ $t('leader.coach.descDoc.subtitle') }}
      </div>
    </div>

    <div class="body defaultCursor">
      <ol>
        <li
          v-for="index in 9"
          :key="`docContent_${index}`"
        >
          {{ $t(`leader.coach.descDoc.content_${index}`) }}
        </li>
      </ol>
    </div>

    <div class="replenish">
      {{ $t('leader.coach.descDoc.replenish') }}
    </div>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        round
        @click="$emit('update:show', false)"
      >
        {{ $t('common.close') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  mixins: [dialog],
};
</script>

<style lang="scss" scoped>
  #introductoryDoc {
    .el-dialog {
      max-width: 95%;

      .header {
        font-size: 16px;
        word-break: break-word;

        .title {
          font-weight: bold;
          padding: 15px 0;
        }
      }

      .body {
        background-color: rgba(239, 245, 243, 0.9);
        font-size: 16px;
        margin-top: 20px;
        padding: 10px 0;
        box-sizing: border-box;

        li {
          padding: 8px 5px;
          word-break: break-word;
        }
      }

      .replenish {
        font-size: 16px;
        padding: 20px 0 0;
        word-break: break-word;
      }
    }

    .content {
      > div {
        text-align: center;
      }
    }
  }
</style>

<style lang="scss">
  #introductoryDoc {
    .el-dialog {
      max-width: 95%;

      .el-dialog__header {
        padding: 10px 0;
      }

      .el-dialog__body {
        padding: 0 4% 5px;
      }

      .el-dialog__footer {
        .dialog-footer {
          padding-bottom: 5px;
        }
      }
    }
  }
</style>
